import { faFileCsv } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme: Theme): StyleRules => ({
  empty: {
    textAlign: 'center',
    margin: theme.spacing(5)
  },
  emptyCsv: {
    margin: theme.spacing(5),
    color: theme.palette.icon.file
  }
});

type DeliveryEmptyProps = WithStyles<typeof styles>;

const DeliveryEmpty: React.FC<DeliveryEmptyProps> = ({ classes }) => (
  <div className={classes.empty} data-cy="emptyContainer">
    <FontAwesomeIcon icon={faFileCsv} className={classes.emptyCsv} size="3x" />
    <Typography variant="subtitle1" color="textSecondary">
      納品物はありません。
    </Typography>
  </div>
);

export default withStyles(styles)(DeliveryEmpty);
